export const server = "https://www.triggercmd.com"